import { type FetchResult, type TypedDocumentNode, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { UPDATE_MEMBER } from 'src/api/memberships.api';
import type { UpdateMembership, UpdateMembershipVariables } from 'types/graphql';
import { TEAM_MEMBERSHIPS_QUERY } from './useMemberships';

const UPDATE_MEMBERSHIP: TypedDocumentNode<UpdateMembership, UpdateMembershipVariables> = UPDATE_MEMBER;

/** Re-points a membership's subsidiary or user; refetches the People grid's member list. */
export function useUpdateMembership() {
  const [mutate, { loading, error }] = useMutation(UPDATE_MEMBERSHIP, { refetchQueries: [TEAM_MEMBERSHIPS_QUERY] });
  const update = useCallback(
    ({ id, input }: UpdateMembershipVariables): Promise<FetchResult<UpdateMembership>> =>
      mutate({ variables: { id, input } }),
    [mutate]
  );

  return { update, loading, error };
}
